module.exports = __webpack_public_path__ + "img/BG.0449188b.jpg";